<script setup lang="ts">

import {PropType} from "vue";
import ButtonComponent from "@components/button.vue";
import {Link} from "@inertiajs/vue3";
import {BlogInterface} from "@interfaces/BlogInterface.js";
import BlogItemComponent from "@components/blog-item.vue";
import { trans } from 'laravel-vue-i18n';

const props = defineProps({
    blogs: {
        type: Array as PropType<BlogInterface[]>,
        required: true,
    },
});

</script>
<template>
    <section id="category-section-blogs">
        <div class="container">
            <header>
                <h2>Blogs</h2>
                <Link
                    :href="route('blogs')"
                >
                    <button-component
                        color="dark-slate"
                    >
                        {{ trans('pages.category.blogs_button') }}
                    </button-component>
                </Link>
            </header>
            <div class="blogs">
                <article
                    v-for="blog in props.blogs"
                    :key="blog.id"
                >
                    <blog-item-component
                        :blog="blog"
                    >
                    </blog-item-component>
                </article>
            </div>
        </div>
    </section>
</template>
<style scoped lang="scss">
@use "@scss/pages/category/sections/blogs";
</style>
